import React, { Component, useContext } from "react";
import { Navigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { BsFillHeartFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { BsPerson, BsCart2 } from "react-icons/bs";
import Swal from "sweetalert2";
import RefreshBearerToken from "./RefreshBearerToken";

import {
  Badge,
  OverlayTrigger,
  Popover,
  ListGroup,
  Dropdown,
  Container,
  Row,
  Col,
} from "react-bootstrap";

import Select from "react-select";

import "../CSS/textanimation.css";
import { Navbar, Nav, Button, Form, FormControl } from "react-bootstrap";
import CartContext from "./CartContext";
import UserLogin from "./UserLoginNew";
import { DemoButton, DemoButtonNav } from "./CommonModules";

export default class Navigation extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      loginRefreshCounter: 1,
      showOverlay: false,
      firstload: false,
    };
  }

  RefreshBearerTokenWithMobileNoOrEmailId = (newval) => {
    this.setState({ loginRefreshCounter: newval + 1 });
    console.log("refresh called");
    this.context.RefreshBearerTokenWithMobileNoOrEmailId(
      this.context.userData.mobileNo,
      this.context.userData
    );
  };
  SignOut = () => {
    //this.setState({ ShowUserLoginNew: true });
  };

  handleOnMouseEnter = () => {
    this.setState({ showOverlay: true });
  };
  handleOnMouseLeave = () => {
    this.setState({ showOverlay: false });
  };

  OnLogin = () => {
    this.context.ShowUserLoginNew(true);
  };

  HideUserLoginNew = () => {
    this.context.ShowUserLoginNew(false);
  };

  componentDidMount() {
    if (this.state.firstload == false) {
      this.state.firstload = true;
      this.context.StoreMyIpAddress();
      this.context.GetEcSettings();
      this.context.GetAllProducts();
      this.context.GetStoreTypes();
      this.context.GetEcProductTypes();
      this.context.GetBusinessTypes();
      this.context.GetStoreStatusTypes();
      this.context.GetBusinessCategories();
    }
  }

  componentWillUnmount() {}
  unload(e) {}

  componentDidUpdate() {}

  render() {
    return (
      <>
        <a
          class="whats-app "
          href={"https://wa.me/" + 9880582728}
          target="_blank"
        >
          <i class="bi bi-whatsapp my-float"></i>
        </a>

        {this.context.userData.loginStatus === "active" ? (
          <RefreshBearerToken></RefreshBearerToken>
        ) : (
          ""
        )}
        {this.context.showUserLoginNew === true ? (
          <UserLogin
            show={this.context.showUserLoginNew}
            onHide={this.HideUserLoginNew}
            logintype="SignIn"
          />
        ) : null}
        <nav class="navbar navbar-expand-lg bg-white navbar-light shadow-sm py-0 py-lg-0 px-1 px-lg-0 ">
          <a href="/home" class="navbar-brand ms-lg-1 border-0 border-dark">
            <h1
              class="p-0 m-0  verticalalignmiddletd"
              style={{
                // fontStyle: "Tangerine, serif",
                fontSize: window.innerWidth > 1200 ? "32px" : "22px",

                color: "green",
                letterSpacing: "2px",
                fontWeight: "bold",
              }}
            >
              <img
                src="https://ecprdstorage01.blob.core.windows.net/elasticcart/images/elasticcart.png"
                className="bg-white rounded-circle me-1"
                height={50}
              ></img>
              Elastic
              <span
                style={{
                  color: "#000080",
                }}
              >
                CART
              </span>{" "}
            </h1>
          </a>
          {window.innerWidth > 1200 ? (
            <></>
          ) : (
            <>
              <div class="">
                {this.context.userData.loginStatus != "active" ? (
                  <>
                    <Button
                      className="verticalaligncentertd bg-white text-dark border-0 border-dark"
                      onClick={(e) => this.OnLogin()}
                      style={{ textTransform: "capitalize" }}
                    >
                      <BsPerson size={"24px"}></BsPerson> {/* Login */}
                    </Button>
                  </>
                ) : (
                  <>
                    <OverlayTrigger
                      show={this.state.showOverlay} // Control trigger behavior with show instead of trigger.
                      key="bottom"
                      placement="bottom"
                      rootClose="false"
                      overlay={
                        <Popover
                          id={`popover-positioned-bottom`}
                          onMouseEnter={this.handleOnMouseEnter}
                          onMouseLeave={this.handleOnMouseLeave}
                          // onClick={this.handleOnMouseEnter}
                          className="navDsn"
                        >
                          <Popover.Header as="h3"></Popover.Header>
                          <Popover.Body>
                            <UserMenu SignOut={this.SignOut}></UserMenu>
                          </Popover.Body>
                        </Popover>
                      }
                    >
                      <Button
                        className="verticalaligncentertd bg-white text-dark border-0 border-dark"
                        onMouseEnter={this.handleOnMouseEnter}
                        onMouseLeave={this.handleOnMouseLeave}
                        style={{ textTransform: "capitalize" }}
                      >
                        <BsPerson size={"22px"}></BsPerson>{" "}
                      </Button>
                    </OverlayTrigger>
                  </>
                )}
              </div>
            </>
          )}

          <button
            class="navbar-toggler border-0 border-dark"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarCollapse">
            <div class="navbar-nav ms-auto py-0 mx-1">
              <a href="/Home" class="nav-item nav-link active">
                Home
              </a>
              <div class="nav-item dropdown">
                <a
                  href="#"
                  class="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Products
                </a>
                <div class="dropdown-menu m-0 " style={{ fontSize: "20px" }}>
                  <a href="/Erp" class="dropdown-item">
                    {
                      this.context.GetProductByType(
                        this.context.ProductType.ERP
                      ).name
                    }
                  </a>
                  <a href="/CrmSales" class="dropdown-item">
                    {
                      this.context.GetProductByType(
                        this.context.ProductType.CRM
                      ).name
                    }
                  </a>
                  <a href="/SupplyChain" class="dropdown-item">
                    {
                      this.context.GetProductByType(
                        this.context.ProductType.SupplyChain
                      ).name
                    }
                  </a>

                  <a href="/POS" class="dropdown-item">
                    {
                      this.context.GetProductByType(
                        this.context.ProductType.Retail_POS
                      ).name
                    }
                  </a>
                  <a href="/PosRestaurant" class="dropdown-item">
                    {
                      this.context.GetProductByType(
                        this.context.ProductType.Restaurant_POS
                      ).name
                    }
                  </a>
                  <a href="/ECommerce" class="dropdown-item ">
                    {
                      this.context.GetProductByType(
                        this.context.ProductType.ECommerce
                      ).name
                    }
                  </a>

                  <a href="/Kiosk" class="dropdown-item">
                    {
                      this.context.GetProductByType(
                        this.context.ProductType.KIOSK_ECommerce
                      ).name
                    }
                  </a>
                  <a href="/QRCodePos" class="dropdown-item">
                    {
                      this.context.GetProductByType(
                        this.context.ProductType.QRCODE_ECommerce
                      ).name
                    }
                  </a>
                  <a href="/Production" class="dropdown-item">
                    {
                      this.context.GetProductByType(
                        this.context.ProductType.ProductionManagement
                      ).name
                    }
                  </a>
                  <a href="/Warehouse" class="dropdown-item">
                    {
                      this.context.GetProductByType(
                        this.context.ProductType.WarehouseManagement
                      ).name
                    }
                  </a>
                  <a href="/HRM" class="dropdown-item">
                    {
                      this.context.GetProductByType(
                        this.context.ProductType.HRM
                      ).name
                    }
                  </a>
                  <a href="/Accounting" class="dropdown-item">
                    {
                      this.context.GetProductByType(
                        this.context.ProductType.Finance
                      ).name
                    }
                  </a>
                </div>
              </div>
              <div class="nav-item dropdown">
                <a
                  href="#"
                  class="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Solutions
                </a>
                <div class="dropdown-menu m-0 " style={{ fontSize: "20px" }}>
                  <a href="/SolutionECommerce" class="dropdown-item">
                    Premium ECommerce Solution for B2C/B2B
                  </a>
                  <a href="/SolutionRetail" class="dropdown-item">
                    Modern Solution for Retail & WholeSale (ERP)
                  </a>
                  <a href="/SolutionRestaurant" class="dropdown-item ">
                    Modern Solution for Restaurant (ERP)
                  </a>
                  <a href="/SolutionManufacturing" class="dropdown-item ">
                    Modern Solution for Manufacturers (ERP)
                  </a>
                  <a href="/SolutionServicing" class="dropdown-item ">
                    Modern Solution for Service Providers (ERP)
                  </a>
                </div>
              </div>
              <a href="/showcase" class="nav-item nav-link">
                Showcase
              </a>
              <a href="/Pricing" class="nav-item nav-link">
                Plan & Price
              </a>
              <div className="verticalaligncentertd">
                &nbsp;&nbsp; &nbsp;&nbsp;
                <DemoButtonNav></DemoButtonNav>
                &nbsp;&nbsp; &nbsp;&nbsp;
              </div>
            </div>
          </div>

          {window.innerWidth > 1200 ? (
            <>
              <div
                class=" navbar-collapse justify-content-end mx-3"
                id="navbarCollapse"
              >
                {this.context.userData.loginStatus != "active" ? (
                  <>
                    <Button
                      className="verticalaligncentertd border-0"
                      onClick={(e) => this.OnLogin()}
                      style={{ textTransform: "capitalize" }}
                    >
                      <BsPerson size={"22px"}></BsPerson> Login
                    </Button>
                  </>
                ) : (
                  <>
                    <OverlayTrigger
                      show={this.state.showOverlay} // Control trigger behavior with show instead of trigger.
                      key="bottom"
                      placement="bottom"
                      rootClose="false"
                      overlay={
                        <Popover
                          id={`popover-positioned-bottom`}
                          onMouseEnter={this.handleOnMouseEnter}
                          onMouseLeave={this.handleOnMouseLeave}
                          className="navDsn"
                        >
                          <Popover.Header as="h3"></Popover.Header>
                          <Popover.Body>
                            <UserMenu SignOut={this.SignOut}></UserMenu>
                          </Popover.Body>
                        </Popover>
                      }
                    >
                      <Button
                        onMouseEnter={this.handleOnMouseEnter}
                        onMouseLeave={this.handleOnMouseLeave}
                        style={{ textTransform: "capitalize" }}
                      >
                        <BsPerson size={"22px"}></BsPerson>{" "}
                        {window.innerWidth > 1200 ? "My Account" : ""}
                      </Button>
                    </OverlayTrigger>
                  </>
                )}
              </div>
            </>
          ) : (
            <></>
          )}
        </nav>
        <a href="#" class="btn btn-primary py-3 fs-4 back-to-top">
          <i class="bi bi-arrow-up"></i>
        </a>
      </>
    );
  }
}

class UserMenu extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const currentUrl = window.location.href;
    const parts = currentUrl.split(/\/+/).filter((part) => part !== "");
    return (
      <>
        <Row className="bg-whie">
          <label className="bg-whie">
            <h4>
              Hi{" "}
              {this.context.userData.firstName
                ? this.context.userData.firstName
                : "Guest!"}
            </h4>
          </label>
        </Row>
        <ListGroup variant="flush" className="fw-bold bg-dark ">
          <ListGroup.Item
            className="navActive"
            as={Link}
            action
            variant="dark"
            to={"/MyProducts"}
          >
            My Products <i className="bi bi-arrow-right me-2"></i>
          </ListGroup.Item>
          <ListGroup.Item
            className="navActive"
            as={Link}
            action
            variant="dark"
            to={"/MyOrders"}
          >
            My Orders <i class="bi bi-arrow-right  me-2"></i>
          </ListGroup.Item>

          <ListGroup.Item
            className="navActive"
            as={Link}
            action
            variant="dark"
            to="/UserProfile"
          >
            My Profile <i class="bi bi-arrow-right  me-2"></i>
          </ListGroup.Item>

          <ListGroup.Item
            as={Link}
            action
            className="navActive mb-0"
            variant="dark"
            to="/home"
            onClick={(e) => {
              Swal.fire({
                title: "Warning!",
                confirmButtonColor: "#23B14D",
                cancelButtonColor: "#dbdbdb",
                text: "Are you sure you want to Signout?",
                showCancelButton: "true",
                cancelButtonText: "No",
                confirmButtonText: "Yes",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.context.clearUserData();
                  this.props.SignOut();
                }
              });
            }}
          >
            Sign Out <i class="bi bi-arrow-right  me-2"></i>
          </ListGroup.Item>
        </ListGroup>
      </>
    );
  }
}
